import Loading from "./Loading";

export default function EmptyState({
  img,
  title,
  description,
  children,
}) {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center space-y-10 max-w-[500px]">
        {children ? (
          children
        ) : (
          <>
            {img ? (
              <img src={img} alt="Empty State" height={300} />
            ) : (
              <Loading shouldShow={true} />
            )}
          </>
        )}
        <div className="flex flex-col items-center justify-center space-y-2">
          {title && (
            <h4 className="text-center text-lg text-secondary">
              {title}
            </h4>
          )}
          {description && (
            <h5 className="text-center text-base text-secondary">
              {description}
            </h5>
          )}
        </div>
      </div>
    </div>
  );
}
